import { useEffect, useMemo, useRef, useState } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import axios from '../../axios';
import { Menu, Paper } from '@mantine/core';

const Example = ({ updateProductModalSetting, handlePageUpdate }) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: 'scheme_name',
        header: 'Scheme Name',
        size: 250,
      },
    ],
    [],
  );

  const rowVirtualizerInstanceRef = useRef(null);

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sorting, setSorting] = useState([]);

  useEffect(() => {
    axios.post('/scheme/getAll')
      .then((res) => setData(res.data))
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  }, [handlePageUpdate]);

  useEffect(() => {
    try {
      rowVirtualizerInstanceRef.current?.scrollToIndex(0);
    } catch (e) {
      console.log(e);
    }
  }, [sorting]);

  const table = useMantineReactTable({
    data,
    columns,
    enableGlobalFilter: true,
    enableColumnFilterModes: true,
    enablePinning: true,
    enablePagination: true,
    enableMultiSort: true, 
    columnFilterDisplayMode:"popover",
    paginationDisplayMode:"pages",
    positionToolbarAlertBanner:"bottom",
    enableColumnResizing: true,
    enableColumnFilter: true,
    enableColumnSelection: true,
    enableGlobalFilter: true,
    enableGlobalFilterModes: true,
    enableStickyHeader: true,
    enableColumnSticky: true,
    enableRowNumbers: true,
    enableRowActions: true,
    renderRowActionMenuItems: ({ row }) => (
      <>
        <Menu.Item onClick={() => updateProductModalSetting(row.original)}>Edit</Menu.Item>
      </>
    ),
  });

  return (
    <Paper shadow="sm" p="lg" withBorder >
      <div style={{width: '100%'}}>
        <MantineReactTable
          table={table}
          striped
          highlightOnHover
          horizontalSpacing="md"
          verticalSpacing="sm"
          fontSize="sm"
          withColumnBorders
          borderRadius="md"
          withGlobalFilter
          height={500}
          rowVirtualizerInstanceRef={rowVirtualizerInstanceRef}
          enablePagination={true}
        />
      </div>
    </Paper>
  );
};

export default Example;
